import h, { FunctionComponent } from 'preact';
import { useState } from 'preact/hooks';
import Currency from '../common/Currency';

const BuyingOptionsSummary: FunctionComponent<BuyingOptionsSummaryProps> = ({
    rows,
    items,
    price,
    addToBasket,
    productItemCount,
    hideTotal,
    isProcessing
}) => {
    const [tableIsVisible, setTableIsVisible] = useState(false);
    const [summaryIsVisible, setSummaryIsVisible] = useState(false);


    const tableObserver = new IntersectionObserver(
        ([entry]) => {
            setTableIsVisible(entry.isIntersecting);
        },
        { rootMargin: '-130px' }
    );

    const summaryObserver = new IntersectionObserver(
        ([entry]) => {
            setSummaryIsVisible(entry.isIntersecting);
        },
        { rootMargin: '-60px' }
    );

    const setObservers = () => {
        const tables = document.querySelectorAll<HTMLElement>('[data-table-normal-head]');
        const summaries = document.querySelectorAll<HTMLElement>('[data-buying-options-summary]');
        const tableId = window.innerWidth < 768 ? 1 : 0;
        tableObserver.observe(tables[tableId]);
        summaryObserver.observe(summaries[tableId]);
    };

    const isDisabled = isProcessing || productItemCount === 0;

        window.addEventListener('load', setObservers);
    window.addEventListener('resize', setObservers);

    return (
        <div class="buying-options__summary row" data-buying-options-summary>
            <div class="col-12 d-flex flex-wrap justify-content-end align-items-center">
                <div class="d-flex flex-wrap justify-content-end align-items-center mb-4 mb-md-0">
                    <span class="buying-options__summary-rows mt-3 my-md-auto">
                        Order Line{rows != 1 ? 's' : ''}: <b>{rows}</b>
                    </span>
                    <span class="buying-options__summary-items mt-3 my-md-auto">
                        Total Item{items != 1 ? 's' : ''}: <b>{items}</b>
                    </span>
                    <span
                        class={`buying-options__summary-price mt-3 my-md-auto ${hideTotal ? 'd-none' : ''} ${
                            tableIsVisible && !summaryIsVisible && isDisabled
                                ? 'mr-190'
                                : ''
                        }`}
                    >
                        Product Total:{' '}
                        <b>
                            <Currency amount={price} />
                        </b>
                    </span>
                </div>

                <button
                    class={`buying-options__add-to-basket btn btn-primary ml-sm-4 ${
                        isDisabled ? 'disabled' : ''
                    } ${
                        tableIsVisible && !summaryIsVisible && !isDisabled ? 'fixed' : ''
                    }`}
                    disabled={isDisabled}
                    aria-label={isDisabled ? 'disabled' : undefined}
                    onClick={addToBasket}
                >
                    <span>Add to Basket</span>
                </button>
            </div>
        </div>
    );
};

interface BuyingOptionsSummaryProps {
    rows: number;
    items: number;
    price: string;
    addToBasket: () => void;
    productItemCount: number;
    hideTotal: boolean;
    isProcessing: boolean;
}

export default BuyingOptionsSummary;
